import { render, staticRenderFns } from "./requisitionManage.vue?vue&type=template&id=23ab3add&scoped=true&"
import script from "./requisitionManage.vue?vue&type=script&lang=js&"
export * from "./requisitionManage.vue?vue&type=script&lang=js&"
import style0 from "./requisitionManage.vue?vue&type=style&index=0&id=23ab3add&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ab3add",
  null
  
)

export default component.exports